<style>
#servitude {
  height: 84px;
}
</style>

<template>
  <vue-custom-scrollbar
    class="v-bar-element"
    v-bind:settings="{suppressScrollY : true}"
    ref="bar-element"
  >
    <div
      class="group"
      v-if="$can('read','transmission_easement_registry')"
    >
      <button
        class="ribbon-button btn--large"
        @click="show('servitudeRegisterModal')"
      >
        <span class="icon">
          <v-icon large>list_alt</v-icon>
        </span>
        <span class="caption">REJESTR SŁUŻEBNOŚCI</span>
      </button>
    </div>
    <div
      class="group"
    >
      <button
        class="ribbon-button btn--large"
        @click="addTransmissionEasement"
      >
        <span class="icon">
          <v-icon large>add_circle</v-icon>
        </span>
        <span class="caption">DODAJ SŁUŻEBNOŚĆ</span>
      </button>
    </div>
    <div
      class="group"
    >
      <button
        class="ribbon-button btn--large"
        @click="toggleServitudesGeom"
        :class="{activeBtn : servitudesVisibility}"
      >
        <img style="width:36px; height:36px;" :src="require('../../../assets/maptools/map_marker_icon.png')">
        <span class="caption">WIZUALIZACJA NA MAPIE</span>
      </button>
    </div>
  </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from 'vue-custom-scrollbar';
export default {
  components: {
    vueCustomScrollbar
  },
  data: vm => ({
    servitudesVisibility: false
  }),
  computed: {
    activeModals() {
      return this.$store.getters.getModalsList;
    }
  },
  methods: {
    addTransmissionEasement() {
      this.$store.commit("setServitudeAdding", true);
      this.$root.$emit('toggleLayer', 'app_layer_Zlotoryja:granice_dzialek', true);
      this.$root.$emit(
        "showSnackbar",
        "info",
        "Wybierz działkę poprzez kliknięcie w jej granicę na mapie"
      );
      this.$root.$emit("identificationFeature", 'start');
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    toggleServitudesGeom() {
       if (this.servitudesVisibility) {
        this.servitudesVisibility = false;
        this.$root.$emit("changeLayerVisibility", {layer: 'transmission_easement', visibility: false});
        this.$emit('hideServitudesFilter');
      } else {
        this.$root.$emit(
          "showSnackbar",
          "#304058",
          "Wybierz na jakiej podstawie klasyfikować służebność"
        );
        this.servitudesVisibility = true;
        this.$root.$emit("addServitudesLayer", {layerName: 'transmission_easement', fullName: 'Służebność', actionName: 'getServitudes'});
        this.$emit('showServitudesFilter');
      }
    }
  },
  beforeDestroy() {
    this.$root.$emit("toggleServitudesLayer", false);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/servitude/Servitude.vue